export default __webpack_public_path__ + "static/iPhoneXFreeMockup1-fffeb82ec19885c922c4217ebaeec4f4.png";